import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { SharedModule } from 'src/app/shared/shared.module';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';


// -- Routing --
import { AppRoutingModule } from './app-routing.module';

// -- Components --
import { AppComponent } from './app.component';
import { InputService } from './services/input.service';
import { FullValuePigService } from './services/full-value-pig.service';
import { DatePipe, LocationStrategy, HashLocationStrategy } from '@angular/common';
import { HttpInterceptors } from './services/http-interceptors';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
//import { MatDatepickerModule, MatNativeDateModule } from '@angular/material';

import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';

@NgModule({ declarations: [
        AppComponent
    ],
    bootstrap: [AppComponent], imports: [SharedModule,
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        HttpClientModule,
        MatDatepickerModule,
        MatNativeDateModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                // useFactory: httpTranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        })], providers: [
        InputService,
        {
            provide: APP_INITIALIZER,
            useFactory: (fullValuePigService: FullValuePigService) => async () => {
                await fullValuePigService.getEnvironment();
                await fullValuePigService.getLoadClientToken();
                if (fullValuePigService.loadClientToken.UserName.length == 0) {
                    fullValuePigService.redirectToLanding();
                }
            },
            deps: [FullValuePigService],
            multi: true
        }, DatePipe, { provide: HTTP_INTERCEPTORS, useClass: HttpInterceptors, multi: true }, { provide: LocationStrategy, useClass: HashLocationStrategy },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}